import { useEffect } from 'react';
import { useAppSettings } from '@/context/app-settings';

/**
 * Hook that automatically applies the background color from app settings
 * to the document root for global application
 */
export function useBackgroundColorApplicator() {
  const { settings, loading } = useAppSettings();

  useEffect(() => {
    // Don't apply anything while loading
    if (loading) {
      console.log('🎨 [BackgroundApplicator] Settings loading, waiting...');
      return;
    }

    const backgroundColor = settings?.theme?.app_background_color;
    
    if (backgroundColor) {
      console.log('🎨 [BackgroundApplicator] Applying background color:', backgroundColor);
      document.documentElement.style.setProperty('--app-background-color', backgroundColor);
    } else {
      console.log('🎨 [BackgroundApplicator] No background color set, using default');
      // Remove the custom property to fall back to default
      document.documentElement.style.removeProperty('--app-background-color');
    }
  }, [settings?.theme?.app_background_color, loading]);

  // Also apply on settings changes (like when user saves a new color)
  useEffect(() => {
    if (!loading && settings) {
      console.log('🎨 [BackgroundApplicator] Settings changed, re-applying background');
    }
  }, [settings, loading]);
}